var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalVolume(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h30v30h-30z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3 8h7l-1.04265206 9.9394913-4.91469588.0605087z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.5 0c-3.5890896 0-6.5.99231847-6.5 2.21749843 0 .05797382.00845376.1149814.02160405.17198898l2.0533237 16.50128029c.07890173.633847.60397398 1.1092323 1.22579479 1.1092323h6.26799133c.61806363 0 1.14031793-.4695879 1.22297693-1.09957l2.1838872-16.49644913c.0150289-.06183874.024422-.12367747.024422-.18744867 0-1.22421373-2.9099711-2.2165322-6.5-2.2165322z",
    stroke: "#000",
    strokeWidth: 2.0244
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalVolume);
export default __webpack_public_path__ + "static/media/totalVolume.9278d4154eecb45b315f9509d1a95b0a.svg";
export { ForwardRef as ReactComponent };